import { defineStore } from 'pinia'
import { ref } from 'vue'
import Cookies from 'js-cookie'
import conf from '@/../tailwind.config.js'


export const useSidebarLayoutStore = defineStore('SidebarLayout', () => {
  const screenSmSize = parseInt(conf.theme.screens.sm)

  // Default sizes based on current layout
  const getWidthValue = (cookieName: string, defaultValue: number): number => {
    const storedValue = Cookies.get(cookieName)
    return storedValue ? +storedValue : defaultValue
  }

  const leftSidebarWidth = ref(getWidthValue('leftSidebarWidth', 33))
  const rightSidebarWidth = ref(getWidthValue('rightSidebarWidth', 33))

  // Update sizes and save to cookies
  const updateLeftSidebarWidth = (width: number) => {
    leftSidebarWidth.value = width
    Cookies.set('leftSidebarWidth', `${width}`, { expires: 365 })
  }

  const updateRightSidebarWidth = (width: number) => {
    rightSidebarWidth.value = width
    Cookies.set('rightSidebarWidth', `${width}`, { expires: 365 })
  }

  return {
    screenSmSize,
    leftSidebarWidth,
    rightSidebarWidth,
    updateLeftSidebarWidth,
    updateRightSidebarWidth
  }
})
